export const NumberRegex = new RegExp(/^[0-9]*$/);
